import BreadcrumbLink from '@/shared/ui/components/BreadcrumbLink';
import type { RoutePathDefinition } from '../../types';

export const taskSectionRoutes: RoutePathDefinition[] = [
  {
    path: '',
    lazy: () => import('@/pages/tasks/ui/MyTasks').then(m => ({ Component: m.default })),
    handle: { crumb: () => <BreadcrumbLink>My Tasks</BreadcrumbLink> }
  }
];
